import {twMerge} from "tailwind-merge";
import {useEffect, useRef} from "react";

export default function CreditCardInput({
                                            label, rowLabel = false, required = false, classes = {}, onChange = () => {
    }
                                        }) {

    const {labelClasses = "", inputClasses = "", parentClasses = "", inputParentClasses = ""} = classes;

    const inputsRef = useRef([]);

    useEffect(() => {
        inputsRef.current = inputsRef.current.slice(0, 4);
    }, []);

    const changeHandler = ({target: {value}}, i) => {
        if (value.length > 4) {
            inputsRef.current[i].value = value.charAt(value.length-1);
        } else if(value.length === 4) {//End of each input
            if (i < inputsRef.current.length - 1) { //End of inputs except last
                inputsRef.current[i + 1].focus()
            } else if (i === inputsRef.current.length - 1) { //End of last input
                inputsRef.current[i].blur()
            }
        }

        let cardNumber = "";
        for (let key in inputsRef.current) {
            cardNumber += inputsRef.current[key].value;
        }

        onChange(cardNumber)
    }

    return (
        <label className={twMerge(rowLabel ? "xl:inline-flex items-center" : "", parentClasses)}>
            {
                label ?
                    <p className={twMerge(`text-sm text-pol-gray ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2 mr-4"}`, labelClasses)}>
                        {label}
                        {
                            required ? <span className="align-super text-pol-red text-sm">*</span> : null
                        }
                    </p>
                    : null
            }
            <div className={twMerge("grid grid-cols-4 gap-x-2 ltr", inputParentClasses)}>
                {
                    Array.from(Array(4), (e, i) => (
                        <input
                            key={i}
                            ref={el => inputsRef.current[i] = el}
                            placeholder="----"
                            inputMode="numeric"
                            type="number"
                            onChange={(e) => changeHandler(e, i)}
                            className={twMerge("border border-pol-light-4 text-center ltr tracking-[0.2em] rounded-2xl py-3.5 outline-none focus:border-pol-main-dark-color duration-300", inputClasses)}
                        />
                    ))
                }
            </div>
        </label>
    )
}
